import { render } from "./RealTime.vue?vue&type=template&id=757de4c0"
import script from "./RealTime.vue?vue&type=script&lang=ts"
export * from "./RealTime.vue?vue&type=script&lang=ts"
script.render = render

export default script